import { render, staticRenderFns } from "./depthSummary.vue?vue&type=template&id=81ec694a"
import script from "./depthSummary.vue?vue&type=script&lang=ts"
export * from "./depthSummary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports